import ContactMe from './ContactMe';
import './footer.css';

export default function Footer() {
  const isNonMobile = window.matchMedia('(min-width: 1020px)').matches;

  return (
    <>
      <footer className='footer-hero-container footer' id='footer'>
        <div className='footer-container'>
          <div
            className='footer-column copy'
            data-aos='fade-up'
            data-aos-duration='300ms'
          >
            <div className='box'>
              <div className='box-inside'>
                <h3 className='autotwo-underline-animation footer-column copy copyhead'>
                  <span
                    className='white-strong'
                    data-aos='flip-up'
                    data-aos-delay='500'
                    data-aos-duration='300ms'
                  >
                    Available
                  </span>{' '}
                  <span className='anime-grad'>for select</span>
                  <span
                    className='white-strong'
                    data-aos='flip-up'
                    data-aos-duration='300ms'
                  >
                    freelance
                  </span>
                  <span className='anime-grad'> opportunities</span>
                </h3>{' '}
                <h3
                  className='footer-column copy smallcopyhead_email'
                  data-aos='flip-up'
                  data-aos-duration='300ms'
                >
                  <a
                    className='chonky-underline-violet has-hover-anim snipcss-4jxlJ style-HyoFo'
                    href='mailto: mikerambil@gmail.com'
                    id='style-HyoFo'
                  >
                    mikerambil@gmail.com
                  </a>
                </h3>
              </div>
              {isNonMobile && (
                <>
                  <h3 className='footer-column copy smallcopyhead hover-underline-animation'>
                    Have an exciting project you need help with?
                  </h3>
                  <p className='footer-paragraphs'>
                    Together, let's build a digital world that's secure,
                    efficient, and boundless.
                  </p>
                  <h3 className='footer-column copy xsmallcopyhead hover-underline-animation'>
                    Send me an email or contact me via instant message!
                  </h3>
                </>
              )}
            </div>
          </div>
          <div
            className='footer-column'
            data-aos='fade-up'
            data-aos-delay='200'
            data-aos-duration='100ms'
          >
            <ContactMe />
          </div>
          <div className='aboutme-author'>
            <div className='ciao-bob'>
              <div class='about-me-content'>
                <div class='about-me-content__container'>
                  <p class='about-me-content__container__text'>Ciao</p>

                  <ul class='about-me-content__container__list'>
                    <li class='about-me-content__container__list__item autotwo-underline-animation'>
                      world !
                    </li>
                    <li class='about-me-content__container__list__item background_aboutme'>
                      bob !
                    </li>
                    <li class='about-me-content__container__list__item autotwo-underline-animation'>
                      users !
                    </li>
                    <li class='about-me-content__container__list__item '>
                      everybody!
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
